// extracted by mini-css-extract-plugin
export default {"container":"Field_container__npqMz","label":"Field_label__+BA9S","value":"Field_value__84CXI"};